import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "../../UI/Progress";

export const MetaResp = (): React.JSX.Element => {
const location = useLocation();
  useEffect(() => {
    if(location.hash){
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const accessToken = hashParams.get("accessToken");
      const channel = new BroadcastChannel("meta-auth-channel");
      channel.postMessage({ accessToken:  accessToken });
      channel.close();
    }
    window.close();
  }, []);
  return <CircularProgress />;
};